import { rem } from 'polished';
import styled from 'styled-components';

import { IUserType } from '../../';
import { IStyledWrapperProps } from './DropDown.types';

export const StyledArrow = styled.span`
  position: absolute;
  right: 0;
  bottom: ${({ theme }) => rem(theme.spacings.m)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => rem(theme.spacings.m)};
  height: ${({ theme }) => rem(theme.spacings.m)};
  pointer-events: none;

  svg {
    width: ${rem('11px')};
    height: auto;
  }
`;

export const StyledSelect = styled.select<IUserType>`
  padding: 0 ${rem('30px')} ${({ theme }) => rem(theme.spacings.xs)} 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  text-indent: 0;
  background-color: ${({ theme }) => theme.colors.main};
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  transition: all 0.5s ease;
  appearance: none;

  &:focus {
    border-bottom-color: ${({ theme, user }) =>
      user && theme.colors[user].main};
    outline: none;
  }
`;

export const StyledLabel = styled.label`
  position: absolute;
  left: 0;
  width: 100%;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  overflow: hidden;
  text-align: left;
`;

export const StyledIcon = styled.span`
  position: absolute;
  left: 0;
  bottom: ${rem('28px')};
  display: block;
  width: ${({ theme }) => rem(theme.spacings.m)};
  height: ${({ theme }) => rem(theme.spacings.m)};
  pointer-events: none;

  & ~ ${StyledSelect}, & ~ ${StyledLabel} {
    padding-left: ${rem('34px')};
  }

  svg {
    max-width: ${rem('22px')};
    height: ${rem('24px')};
  }
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: ${rem('29px')};
  padding-bottom: ${rem('20px')};

  ${({ isActive }) =>
    isActive &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}

  ${({ isEmpty }) =>
    isEmpty &&
    `
    ${StyledLabel} {
      top: ${rem('30px')};
    }
  `}

  ${({ isActive, isEmpty }) =>
    isActive &&
    !isEmpty &&
    `
    ${StyledLabel} {
      padding-left: 0;
    }
  `}
`;
